export default {
  "enums": {
    "volume": {
      "attrName": "volume",
      "objectId": "175c44a056f49bd638556395cecd88f800000000",
      "displayName": "Объем",
      "defaultValue": "volumeStandard",
      "price": 0,
      "values": {
        "volumeSlim": {
          "attrValue": "volumeSlim",
          "objectId": "748bc8ee18e3aac6d9c549ab069b9d8600000000",
          "displayName": "Объем приталенный",
          "shortName": "приталенный",
          "price": 0,
          "sortPosition": 0
        },
        "volumeStandard": {
          "attrValue": "volumeStandard",
          "objectId": "397f8d3ba596a16d84c082e2be61473700000000",
          "displayName": "Объем стандартный",
          "shortName": "стандартный",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "collar": {
      "attrName": "collar",
      "objectId": "437f07dcc7fe85bad4a6566e48775b6700000000",
      "displayName": "Воротник",
      "defaultValue": "Mao",
      "price": 0,
      "values": {
        "collarMao": {
          "attrValue": "collarMao",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "Mao",
          "shortName": "Mao",
          "price": 0,
          "sortPosition": 1
        },
        "collarMandarin": {
          "attrValue": "collarMandarin",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "Mandarin",
          "shortName": "Mandarin",
          "price": 0,
          "sortPosition": 1
        },
        "collarKing": {
          "attrValue": "collarKing",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "King",
          "shortName": "King",
          "price": 0,
          "sortPosition": 1
        },
        "collarCutaway": {
          "attrValue": "collarCutaway",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "Cutaway",
          "shortName": "Cutaway",
          "price": 0,
          "sortPosition": 1
        },
        "collarKent": {
          "attrValue": "collarKent",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "Kent",
          "shortName": "Kent",
          "price": 0,
          "sortPosition": 1
        },
        "collarWindsor": {
          "attrValue": "collarWindsor",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "Windsor",
          "shortName": "Windsor",
          "price": 0,
          "sortPosition": 1
        },
        "collarRoma": {
          "attrValue": "collarRoma",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "Roma",
          "shortName": "Roma",
          "price": 0,
          "sortPosition": 1
        },
        "collarColorado": {
          "attrValue": "collarColorado",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "Colorado",
          "shortName": "Colorado",
          "price": 0,
          "sortPosition": 1
        },
        "collarColoradoMini": {
          "attrValue": "collarColoradoMini",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "Colorado Mini",
          "shortName": "Colorado Mini",
          "price": 0,
          "sortPosition": 1
        },
        "collarLondoner": {
          "attrValue": "collarLondoner",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "Londoner",
          "shortName": "Londoner",
          "price": 0,
          "sortPosition": 1
        },
        "collarVintageClubMini": {
          "attrValue": "collarVintageClubMini",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "Vintage Club Mini",
          "shortName": "Vintage Club Mini",
          "price": 0,
          "sortPosition": 1
        },
        "collarVintageClub": {
          "attrValue": "collarVintageClub",
          "objectId": "1aca4e330e60324013898f31a7aae2e71441f8ab",
          "displayName": "Vintage Club",
          "shortName": "Vintage Club",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "collarWhite": {
      "attrName": "collarWhite",
      "objectId": "c816d21f02b02b1d1a208abe0364b45500000000",
      "displayName": "Воротник белый",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "true": {
          "attrValue": "true",
          "objectId": "7908d0175ad1c7dc7f00891df8cad44900000000",
          "displayName": "Воротник белый",
          "shortName": "белый",
          "price": 0,
          "sortPosition": 0
        },
        "false": {
          "attrValue": "false",
          "objectId": "1d3c4856e0e4a81af3ddfa2d2906a0f900000000",
          "displayName": "Воротник под цвет ткани",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "sleeve": {
      "attrName": "sleeve",
      "objectId": "ce8f26dc2859d7412980bec48e7ab63e00000000",
      "displayName": "Рукав",
      "defaultValue": "sleeveLong",
      "price": 0,
      "values": {
        "sleeveLong": {
          "attrValue": "sleeveLong",
          "objectId": "eb858a9f457450aaeb9caf3e62e1aa5400000000",
          "displayName": "Длинный",
          "shortName": "Длинный",
          "price": 0,
          "sortPosition": 0
        },
        "sleeveShort": {
          "attrValue": "sleeveShort",
          "objectId": "c257e820895a822083ad76008e64f6a500000000",
          "displayName": "Короткий",
          "shortName": "Короткий",
          "price": 0,
          "sortPosition": 2
        },
        "sleeveShortCuff": {
          "attrValue": "sleeveShortCuff",
          "objectId": "ebb6c0a2673ea31eadfcdc580be969ac00000000",
          "displayName": "Рукав короткий с планкой",
          "shortName": "Короткий с планкой",
          "price": 0,
          "sortPosition": 3
        }
      }
    },
    "cuff": {
      "attrName": "cuff",
      "objectId": "cefaeea1c1cadfb92186854dbdada5d800000000",
      "displayName": "Манжеты",
      "defaultValue": "cuffOneButton",
      "price": 0,
      "values": {
        "cuffFrench": {
          "attrValue": "cuffFrench",
          "objectId": "6c49a9f0e2eae482c7d2fa802ec7bc9c00000000",
          "displayName": "French",
          "shortName": "cuffFrench",
          "price": 200,
          "sortPosition": 0
        },
        "cuffTwoButtons": {
          "attrValue": "cuffTwoButtons",
          "objectId": "3240b98bc51d7fa4e7418a265807f61a00000000",
          "displayName": "Two buttons",
          "shortName": "Two buttons",
          "price": 0,
          "sortPosition": 1
        },
        "cuffRegulated": {
          "attrValue": "cuffRegulated",
          "objectId": "33db674f86e449c90d051d34d90dc7f100000000",
          "displayName": "Regulated",
          "shortName": "Regulated",
          "price": 0,
          "sortPosition": 2
        },
        "cuffRounded": {
          "attrValue": "cuffRounded",
          "objectId": "a345ff2f3e80f56bb96ff72cc1a6986900000000",
          "displayName": "Rounded",
          "shortName": "Rounded",
          "price": 200,
          "sortPosition": 3
        },
        "cuffStraight": {
          "attrValue": "cuffStraight",
          "objectId": "4cdfb3a6e509a507eed5d281a868cc19af2fd4b8",
          "displayName": "Straight",
          "shortName": "Straight",
          "price": 0,
          "sortPosition": 4
        }
      }
    },
    "cuffStyle": {
      "attrName": "cuffStyle",
      "objectId": "bd2dabab74e7766608e7d44dbf9d61c000000000",
      "displayName": "Углы манжеты",
      "defaultValue": "cuffStyleStraight",
      "price": 0,
      "values": {
        "cuffStyleTruncated": {
          "attrValue": "cuffStyleTruncated",
          "objectId": "93408a62666feb5f66344c6118c7b56300000000",
          "displayName": "Углы манжеты срезанные",
          "shortName": "Срезанные",
          "price": 0,
          "sortPosition": 0
        },
        "cuffStyleRound": {
          "attrValue": "cuffStyleRound",
          "objectId": "630757c7bcd7d1dff6eab12a80b8036900000000",
          "displayName": "Углы манжеты скругленные",
          "shortName": "Скругленные",
          "price": 0,
          "sortPosition": 1
        },
        "cuffStyleStraight": {
          "attrValue": "cuffStyleStraight",
          "objectId": "cf10d7b27f7370d58576302c5497ae1c00000000",
          "displayName": "Углы манжеты прямые",
          "shortName": "Прямые",
          "price": 0,
          "sortPosition": 2
        },
        "cuffStyleBeveled": {
          "attrValue": "cuffStyleBeveled",
          "objectId": "cf10d7b27f7370d58576302c5497ae1c00000000",
          "displayName": "Углы Скошенные",
          "shortName": "Скошенные",
          "price": 0,
          "sortPosition": 2
        }
      }
    },
    "cuffDensity": {
      "attrName": "cuffDensity",
      "objectId": "774500ad35bf745f9fb518a788114e1391c479e0",
      "displayName": "Плотность манжет",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "soft": {
          "attrValue": "soft",
          "objectId": "cd703d78a25b74fca70a8eb8f1d68ce4ad5d489c",
          "displayName": "Мягкие",
          "shortName": "Мягкие",
          "price": 0,
          "sortPosition": 0
        },
        "medium": {
          "attrValue": "medium",
          "objectId": "013b156c42e0f29099a0800c122f25cd864e7aa5",
          "displayName": "Средние",
          "shortName": "Средние",
          "price": 0,
          "sortPosition": 1
        },
        "hard": {
          "attrValue": "hard",
          "objectId": "013b156c42e0f29099a0800c122f25cd864e7aa5",
          "displayName": "Жесткие",
          "shortName": "Жесткие",
          "price": 0,
          "sortPosition": 2
        }
      }
    },
    "cuffWhite": {
      "attrName": "cuffWhite",
      "objectId": "17b01ddf4eb6b504d54f984ff49f856d00000000",
      "displayName": "Манжеты белые",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "true": {
          "attrValue": "true",
          "objectId": "7f71fe01bb6d6abc094dd017b48f302500000000",
          "displayName": "Манжеты белые",
          "shortName": "белые",
          "price": 0,
          "sortPosition": 0
        },
        "false": {
          "attrValue": "false",
          "objectId": "e37a572abdbb5e2a89b5aaf862f62c2900000000",
          "displayName": "Манжеты под цвет ткани",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "fastening": {
      "attrName": "fastening",
      "objectId": "979932b7dd64eb67a04f500369bd938000000000",
      "displayName": "Застежка",
      "defaultValue": "fasteningPlank",
      "price": 0,
      "values": {
        "fasteningStandard": {
          "attrValue": "fasteningStandard",
          "objectId": "af06e488e0f49b1b9334c7e0743decd000000000",
          "displayName": "Застежка стандартная",
          "shortName": "Стандартная",
          "price": 0,
          "sortPosition": 0
        },
        "fasteningPlank": {
          "attrValue": "fasteningPlank",
          "objectId": "6970e7a0fc546a87868b9be98f6ef55300000000",
          "displayName": "Застежка с планкой",
          "shortName": "С планкой",
          "price": 0,
          "sortPosition": 1
        },
        "fasteningStandardBone": {
          "attrValue": "fasteningStandardBone",
          "objectId": "fasteningStandardBone",
          "displayName": "Застежка с косточками",
          "shortName": "С косточками",
          "price": 600,
          "sortPosition": 2
        },
        "fasteningHidden": {
          "attrValue": "fasteningHidden",
          "objectId": "318f29214e59b817834cfcc5e3725d9e00000000",
          "displayName": "Застежка потайная",
          "shortName": "Потайная",
          "price": 0,
          "sortPosition": 3
        }
      }
    },
    "pocket": {
      "attrName": "pocket",
      "objectId": "3aab772ff66c434e9a7e98ef1152cd5900000000",
      "displayName": "Карманы",
      "defaultValue": "pocketNone",
      "price": 0,
      "values": {
        "pocketNone": {
          "attrValue": "pocketNone",
          "objectId": "9d2a6073aa897dcf2dc71d463816647000000000",
          "displayName": "Без карманов",
          "shortName": "без карманов",
          "price": 0,
          "sortPosition": 4
        },
        "pocketLeft": {
          "attrValue": "pocketLeft",
          "objectId": "d82742a3e134ea0348edf1fe6cada5b400000000",
          "displayName": "Карман один стандартный",
          "shortName": "один стандартный",
          "price": 0,
          "sortPosition": 0
        },
        "pocketLeftRound": {
          "attrValue": "pocketLeftRound",
          "objectId": "b11fbdd9a3a3e50c08113125ce54553000000000",
          "displayName": "Карман один скругленный",
          "shortName": "один скругленный",
          "price": 0,
          "sortPosition": 1
        },
        "pocketBoth": {
          "attrValue": "pocketBoth",
          "objectId": "2e36793c3af7240ba1c7acf679cf1a1f00000000",
          "displayName": "Два стандартных кармана",
          "shortName": "два стандартных",
          "price": 100,
          "sortPosition": 2
        },
        "pocketBothRound": {
          "attrValue": "pocketBothRound",
          "objectId": "a626a7a3b6884a79a37d2001e169ba1e00000000",
          "displayName": "Два скругленных кармана",
          "shortName": "два скругленных",
          "price": 100,
          "sortPosition": 3
        }
      }
    },
    "pocketButton": {
      "attrName": "pocketButton",
      "objectId": "63a0148fba50de266159b6d673ababbf00000000",
      "displayName": "Карманы с пуговицей",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "true": {
          "attrValue": "true",
          "objectId": "4cf965feb399556ef9e13ecf8be983b000000000",
          "displayName": "Карманы с пуговицей",
          "shortName": "да",
          "price": 0,
          "sortPosition": 0
        },
        "false": {
          "attrValue": "false",
          "objectId": "a60611c88e7ae52e1597b6040187a8d600000000",
          "displayName": "Карманы без пуговиц",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "pocketFlap": {
      "attrName": "pocketFlap",
      "objectId": "586cd0eda831b963dd452ee96531be6b00000000",
      "displayName": "Карман с клапаном",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "false": {
          "attrValue": "false",
          "objectId": "b03054286d1aee01cb5d63083787e2a700000000",
          "displayName": "Карман без клапана",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 0
        },
        "true": {
          "attrValue": "true",
          "objectId": "7a2e1969614a09b1648bf5d3d0e1619b00000000",
          "displayName": "Карман с клапаном",
          "shortName": "клапан",
          "price": 100,
          "sortPosition": 1
        }
      }
    },
    "bottomCut": {
      "attrName": "bottomCut",
      "objectId": "8d4bc5faf21298f278cc3d077bf6143400000000",
      "displayName": "Низ рубашки",
      "defaultValue": "bottomCutStraight",
      "price": 0,
      "values": {
        "bottomCutStraight": {
          "attrValue": "bottomCutStraight",
          "objectId": "310dd132f5f02756280eb98f32682fe000000000",
          "displayName": "Низ рубашки прямой",
          "shortName": "прямой",
          "price": 0,
          "sortPosition": 0
        },
        "bottomCutFigure": {
          "attrValue": "bottomCutFigure",
          "objectId": "d8013b56b75a06b3e82721f480fdc02800000000",
          "displayName": "Низ рубашки фигурный",
          "shortName": "фигурный",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "epaulettes": {
      "attrName": "epaulettes",
      "objectId": "63a2f2d95de390c742f4827d944ac3da00000000",
      "displayName": "Погоны",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "true": {
          "attrValue": "true",
          "objectId": "d9ff76207e941620f5ffb87bc4c5f17b00000000",
          "displayName": "С  погонами",
          "shortName": "да",
          "price": 200,
          "sortPosition": 0
        },
        "false": {
          "attrValue": "false",
          "objectId": "b7b65c1ebe4d8fda4ae1ea9161f6612600000000",
          "displayName": "Без погон",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "patch": {
      "attrName": "patch",
      "objectId": "75f347c1460dae7c0a68ec11d4ac15ee167dac2f",
      "displayName": "Заплатки на локтях",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "true": {
          "attrValue": "true",
          "objectId": "d9ff76207e941620f5ffb87bc4c5f17b56000000",
          "displayName": "С  заплатками",
          "shortName": "да",
          "price": 200,
          "sortPosition": 0
        },
        "false": {
          "attrValue": "false",
          "objectId": "b7b65c1ebe4d8fda4ae1ea9161f6612656000000",
          "displayName": "Без заплаток",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "backPleats": {
      "attrName": "backPleats",
      "objectId": "922f46d0e0c315452547d93d659071f400000000",
      "displayName": "Спинка",
      "defaultValue": "backPleatsNone",
      "price": 0,
      "values": {
        "backPleatsNone": {
          "attrValue": "backPleatsNone",
          "objectId": "ee3e1e657b304fce157c22c1f1aebdbb00000000",
          "displayName": "с кокеткой без складок",
          "shortName": "Без складок",
          "price": 0,
          "sortPosition": 0
        },
        "backPleatsCenter": {
          "attrValue": "backPleatsCenter",
          "objectId": "b35ebd04bbda8f669615b45191a11f0f00000000",
          "displayName": "с кокеткой и бантовой складкой посередине",
          "shortName": "Складки посередине",
          "price": 0,
          "sortPosition": 1
        },
        "backPleatsSides": {
          "attrValue": "backPleatsSides",
          "objectId": "9736ca6703ba148d111befc8e73449b700000000",
          "displayName": "с кокеткой и складками по бокам",
          "shortName": "Складки по бокам",
          "price": 0,
          "sortPosition": 2
        },
        "backPleatsComposite": {
          "attrValue": "backPleatsComposite",
          "objectId": "ac428603493fe69fbaab856227fef9f97257b0f6",
          "displayName": "с составной кокеткой",
          "shortName": "Составная",
          "price": 0,
          "sortPosition": 3
        }
      }
    },
    "collarHeight": {
      "attrName": "collarHeight",
      "objectId": "2fc6dcec0b9810ec95fad4d085d93da300000000",
      "displayName": "Высота воротника",
      "defaultValue": "collarHeight35mm",
      "price": 0,
      "values": {
        "collarHeight35mm": {
          "attrValue": "collarHeight35mm",
          "objectId": "0f5a29e22e04d3a09656c6589141e5f200000000",
          "displayName": "Воротник 3.5 см.",
          "shortName": "3.5 см.",
          "price": 0,
          "sortPosition": 0
        },
        "collarHeight40mm": {
          "attrValue": "collarHeight40mm",
          "objectId": "5592b6ae0d461cba0d3f27d190f08c7400000000",
          "displayName": "Воротник 4 см.",
          "shortName": "4 см.",
          "price": 0,
          "sortPosition": 1
        },
        "collarHeight45mm": {
          "attrValue": "collarHeight45mm",
          "objectId": "6b9c1012214618281f2f9b512edd4a6d00000000",
          "displayName": "Воротник 4.5 см.",
          "shortName": "4.5 см.",
          "price": 0,
          "sortPosition": 2
        },
        "collarHeight45mm2button": {
          "attrValue": "collarHeight45mm2button",
          "objectId": "a1f003c669e97d4ea29f6b51efb159f16a08ad68",
          "displayName": "Воротник 4.5 см. на 2 пуг.",
          "shortName": "4.5 см. на 2 пуг.",
          "price": 0,
          "sortPosition": 3
        },
        "collarHeight50mm3button": {
          "attrValue": "collarHeight50mm3button",
          "objectId": "0954e8bd14a31368fa5a58bcee63033a6421b3f7",
          "displayName": "Воротник 5 см. на 3 пуг.",
          "shortName": "5 см. на 3 пуг.",
          "price": 100,
          "sortPosition": 4
        },
        "collarHeight55mm4button": {
          "attrValue": "collarHeight55mm4button",
          "objectId": "99f70890f5173e80cc8d238e3acf1d143ecbaba4",
          "displayName": "Воротник 5,5 см. на 4 пуг.",
          "shortName": "5,5 см. на 4 пуг.",
          "price": 100,
          "sortPosition": 5
        }
      }
    },
    "collarBone": {
      "attrName": "collarBone",
      "objectId": "81990b5e1e5fea88de9ad46af431bad700000000",
      "displayName": "Косточка в воротнике",
      "defaultValue": "false",
      "price": 150,
      "values": {
        "true": {
          "attrValue": "true",
          "objectId": "5ed6f3ab591b630c2a1cd5bca50c8f2300000000",
          "displayName": "С косточкой в воротнике",
          "shortName": "косточка",
          "price": 150,
          "sortPosition": 0
        },
        "false": {
          "attrValue": "false",
          "objectId": "23bfa4fbcdd508d3c907cef8bce748f500000000",
          "displayName": "Без косточки в воротнике",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "collarButtons": {
      "attrName": "collarButtons",
      "objectId": "8454917bf195a07a2ddc15d502c2937800000000",
      "displayName": "Потайные пуговицы на воротнике",
      "defaultValue": "false",
      "price": 150,
      "values": {
        "true": {
          "attrValue": "true",
          "objectId": "93a728f097568ac3ee41ed2ebb92772400000000",
          "displayName": "С потайными пуговицами",
          "shortName": "потайная пуговица",
          "price": 150,
          "sortPosition": 0
        },
        "false": {
          "attrValue": "false",
          "objectId": "4abede5234fa2abe0ab6c67e230e736500000000",
          "displayName": "Без потайных пуговиц",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "sleeveBottom": {
      "attrName": "sleeveBottom",
      "objectId": "a2cf65dd7f0ec736458c0a5c68fff02f00000000",
      "displayName": "Низ рукава",
      "defaultValue": "sleeveBottomPlank1Btn",
      "price": 0,
      "values": {
        "sleeveBottomPlank": {
          "attrValue": "sleeveBottomPlank",
          "objectId": "444b2a2dc157732edf6580496a860f5a00000000",
          "displayName": "Низ рукава с планкой",
          "shortName": "с планкой",
          "price": 0,
          "sortPosition": 0
        },
        "sleeveBottomPlank1Btn": {
          "attrValue": "sleeveBottomPlank1Btn",
          "objectId": "22de7d6138610da2b0774b86ca840a0900000000",
          "displayName": "Низ рукава с планкой на 1 пуговицу",
          "shortName": "планка, пуговица",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "collarDensity": {
      "attrName": "collarDensity",
      "objectId": "f461e33ad79c287f0a4346fa23e976f200000000",
      "displayName": "Плотность воротника",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "soft": {
          "attrValue": "soft",
          "objectId": "4c12fcc93e9a404103cc37b5bfb324b000000000",
          "displayName": "Мягкая",
          "shortName": "жесткий",
          "price": 0,
          "sortPosition": 0
        },
        "medium": {
          "attrValue": "medium",
          "objectId": "9c1ef3abf306cc29205974220766097c00000000",
          "displayName": "Средняя",
          "shortName": "Средняя",
          "price": 0,
          "sortPosition": 1
        },
        "hard": {
          "attrValue": "hard",
          "objectId": "9c1ef3abf306cc29205974220766097c00000000",
          "displayName": "Жесткая",
          "shortName": "Жесткая",
          "price": 0,
          "sortPosition": 2
        }
      }
    },
    "suspended": {
      "attrName": "suspended",
      "objectId": "822ee414d930bb93a670714aa917a545393ce9e4",
      "displayName": "Premium",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "false": {
          "attrValue": "false",
          "objectId": "afd15899f18a0ffd557f6619bbf3c37754737b80",
          "displayName": "Без элементов",
          "shortName": "без элементов",
          "price": 0,
          "sortPosition": 0
        },
        "true": {
          "attrValue": "true",
          "objectId": "dfd15899f18a0ffd557f6619bbf3c37754737b80",
          "displayName": "Premium",
          "shortName": "Premium",
          "price": 1900,
          "sortPosition": 1
        },
      }
    },
    "buttonsThread": {
      "attrName": "buttonsThread",
      "objectId": "f5bc25b78dee8ca2f5ca5479b3b74caa00000000",
      "displayName": "Обметка петли пуговицы",
      "defaultValue": "t0000",
      "price": 0,
      "values": {
        "3548": {
          "attrValue": "3548",
          "objectId": "0888bb222bef9c9777873808a017458207fb3fd6",
          "displayName": "3548",
          "shortName": "бирюза",
          "price": 150,
          "sortPosition": 22
        },
        "3827": {
          "attrValue": "3827",
          "objectId": "2df0317a99c83652bb170151fdc0c290ccdfaa2c",
          "displayName": "3827",
          "shortName": "светло сиреневый",
          "price": 150,
          "sortPosition": 18
        },
        "3971": {
          "attrValue": 3971,
          "objectId": "dc8367940e132bbef5b3d529a8e403c3aebd9e81",
          "displayName": 3971,
          "shortName": "салатовый",
          "price": 150,
          "sortPosition": 7
        },
        "t0000": {
          "attrValue": "t0000",
          "objectId": "48be2e2b518c6a5859f7bc1a577eb2f800000000",
          "displayName": "Обметка стандартная по типу ткани",
          "shortName": "по типу ткани",
          "price": 0,
          "sortPosition": 0
        },
        "00088": {
          "attrValue": "00088",
          "objectId": "82e67d236c74daf6d17a5cb405fe5f9eb2f8df91",
          "displayName": "00088",
          "shortName": "голубой",
          "price": 150,
          "sortPosition": 1
        },
        "00428": {
          "attrValue": "00428",
          "objectId": "1b82402f630aae2a6208b8be6be637aba205f678",
          "displayName": "00428",
          "shortName": "красный",
          "price": 150,
          "sortPosition": 2
        },
        "01700": {
          "attrValue": "01700",
          "objectId": "6bbb80a59624897fb5c1a52e74e2032191fd2aea",
          "displayName": "01700",
          "shortName": "белый",
          "price": 150,
          "sortPosition": 3
        },
        "07342": {
          "attrValue": "07342",
          "objectId": "172984a883b46b39f5e52dbe03748c23566301d9",
          "displayName": "07342",
          "shortName": "синий",
          "price": 150,
          "sortPosition": 4
        },
        "08313": {
          "attrValue": "08313",
          "objectId": "67a2d0e8dc727f6a0578a919a1ea302201edffa4",
          "displayName": "08313",
          "shortName": "розовый",
          "price": 150,
          "sortPosition": 5
        },
        "Y0274": {
          "attrValue": "Y0274",
          "objectId": "b179c6116ada94ea95a1131887f78e4c7776f508",
          "displayName": "Y0274",
          "shortName": "черный",
          "price": 150,
          "sortPosition": 6
        },
        "0634": {
          "attrValue": "0634",
          "objectId": "f2bd0e1b6956359a0a535bbd9d131647c443ab04",
          "displayName": "0634",
          "shortName": "серый",
          "price": 150,
          "sortPosition": 8
        },
        "0417": {
          "attrValue": "0417",
          "objectId": "53f5af0f5bcf7d7ee6b1dd0711948cb70f4e920d",
          "displayName": "0417",
          "shortName": "желтый",
          "price": 150,
          "sortPosition": 9
        },
        "0249": {
          "attrValue": "0249",
          "objectId": "17a4e960b401043a085b9c0b1491a71fde82df69",
          "displayName": "0249",
          "shortName": "бежевый",
          "price": 150,
          "sortPosition": 10
        },
        "0218": {
          "attrValue": "0218",
          "objectId": "0880fd7a1f1beb3bd7ed6456071699c53b19e658",
          "displayName": "0218",
          "shortName": "темно синий",
          "price": 150,
          "sortPosition": 11
        },
        "0179": {
          "attrValue": "0179",
          "objectId": "f0e7ecc5082f9a87fa9967ef613f9c2d866a7b1c",
          "displayName": "0179",
          "shortName": "персик",
          "price": 150,
          "sortPosition": 12
        },
        "0044": {
          "attrValue": "0044",
          "objectId": "b2d7d45099e343b20ff88de6d8f73ccf2b6802a6",
          "displayName": "0044",
          "shortName": "коралл",
          "price": 150,
          "sortPosition": 13
        },
        "0174": {
          "attrValue": "0174",
          "objectId": "426eac44a33019273acee6831ac6dfd9536117c1",
          "displayName": "0174",
          "shortName": "шоколад",
          "price": 150,
          "sortPosition": 14
        },
        "0363": {
          "attrValue": "0363",
          "objectId": "de8cbe6c5ac889eb8958d0930e3b8a16913967bc",
          "displayName": "0363",
          "shortName": "рыжий",
          "price": 150,
          "sortPosition": 15
        },
        "0375": {
          "attrValue": "0375",
          "objectId": "a19409423d9fea94ebe49ca4dc6b61842f9b8702",
          "displayName": "0375",
          "shortName": "брусника",
          "price": 150,
          "sortPosition": 16
        },
        "0607": {
          "attrValue": "0607",
          "objectId": "dbdbbaaa76f0b29e8c168719420f4c2f6f8ea787",
          "displayName": "0607",
          "shortName": "бордо",
          "price": 150,
          "sortPosition": 17
        },
        "0575": {
          "attrValue": "0575",
          "objectId": "5abb7cf722695469ad3bd9f288154a84b30bd977",
          "displayName": "0575",
          "shortName": "слива",
          "price": 150,
          "sortPosition": 19
        },
        "0191": {
          "attrValue": "0191",
          "objectId": "859f74a2e5f1c1ffcc391efcb74d7802da0daf25",
          "displayName": "0191",
          "shortName": "морская волна",
          "price": 150,
          "sortPosition": 20
        },
        "0402": {
          "attrValue": "0402",
          "objectId": "481103f056eae647329f7fc558dd2815b607eaf0",
          "displayName": "0402",
          "shortName": "изумруд",
          "price": 150,
          "sortPosition": 21
        }
      }
    },
    "embroidery": {
      "attrName": "embroidery",
      "objectId": "df6dbf2eeb6d47d6a74bb05d52890a5800000000",
      "displayName": "Расположение",
      "defaultValue": "embroideryNone",
      "price": 200,
      "values": {
        "embroideryNone": {
          "attrValue": "embroideryNone",
          "objectId": "8c0bbc0a09bd15cff05d364d0760072100000000",
          "displayName": "Без вышивки",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 0
        },
        "embroideryAtPocket": {
          "attrValue": "embroideryAtPocket",
          "objectId": "39ac876c51ebe320aa0f12e5bd05592000000000",
          "displayName": "С вышивкой на кармане",
          "shortName": "на кармане",
          "price": 0,
          "sortPosition": 1
        },
        "embroideryAtCuff": {
          "attrValue": "embroideryAtCuff",
          "objectId": "3c207d6f195027579ba02ccf043c696f00000000",
          "displayName": "С вышивкой на манжете",
          "shortName": "на манжете",
          "price": 0,
          "sortPosition": 2
        },
        "embroideryAtChest": {
          "attrValue": "embroideryAtChest",
          "objectId": "c3687a1251ffa5dfee5aa074ab3d9a54f25fc38b",
          "displayName": "С вышивкой на груди",
          "shortName": "на груди",
          "price": 0,
          "sortPosition": 3
        },
        "embroideryAtFront": {
          "attrValue": "embroideryAtFront",
          "objectId": "embroideryAtFront",
          "displayName": "C вышивкой с боку",
          "shortName": "на боку",
          "price": 0,
          "sortPosition": 4
        }
      }
    },
    // "addEmbroidery": { 
    //   "attrName": "addEmbroidery",
    //   "objectId": "90a278d256538bd917fa2df1699890d4730be84c",
    //   "displayName": "Добавить вышивку",
    //   "shortName": "Добавить вышивку",
    //   "defaultValue": "false",
    //   "price": 0,
    //   "values": {
    //     "false": {
    //       "attrValue": "false",
    //       "objectId": "70575abdfafd652c8de88004eeb958fc2f19d30a",
    //       "displayName": "Не добавлять вышивку",
    //       "shortName": "нет",
    //       "sortPosition": 0
    //     },
    //     "true": {
    //       "attrValue": "true",
    //       "objectId": "80489e3462b2624ae91ed671d6e4364e154f67c1",
    //       "displayName": "Добавить вышивку",
    //       "shortName": "да",
    //       "sortPosition": 1
    //     }
    //   }
    // },
    "embroideryFont": {
      "attrName": "embroideryFont",
      "objectId": "a277cb60219f6bc42f4ead288b5ba54e00000000",
      "displayName": "Шрифт монограммы",
      "defaultValue": "Arial",
      "price": 0,
      "values": {
        "Arial": {
          "attrValue": "Arial",
          "objectId": "3a65431043025f9e7e7d9239a9978f2100000000",
          "displayName": "Arial",
          "shortName": "Arial",
          "price": 0,
          "sortPosition": 0
        },
        "MonotypeCorsiva": {
          "attrValue": "MonotypeCorsiva",
          "objectId": "d0eda81155652f32ea43f84e1d47a3602c96db66",
          "displayName": "Monotype Corsiva",
          "shortName": "Monotype Corsiva",
          "price": 0,
          "sortPosition": 1
        },
        "OldEnglish": {
          "attrValue": "OldEnglish",
          "objectId": "f82cc721a4ee819e2b1fb0c98a9cff201381d305",
          "displayName": "Old English",
          "shortName": "Old English",
          "price": 0,
          "sortPosition": 2
        },
        "MiniCorsiva": {
          "attrValue": "MiniCorsiva",
          "objectId": "MiniCorsiva",
          "displayName": "Mini Corsiva",
          "shortName": "Mini Corsiva",
          "price": 0,
          "sortPosition": 3
        },
        "Verdana": {
          "attrValue": "Verdana",
          "objectId": "Verdana",
          "displayName": "Verdana",
          "shortName": "Verdana",
          "price": 0,
          "sortPosition": 4
        }
      }
    },
    "embroideryColor": {
      "attrName": "embroideryColor",
      "objectId": "ae9cbe62b5414191a4727cddc6411d6600000000",
      "displayName": "Цвет вышивки",
      "defaultValue": "01700",
      "price": 0,
      "values": {
        "00088": {
          "attrValue": "00088",
          "objectId": "82e67d236c74daf6d17a5cb405fe5f9eb2f8df91",
          "displayName": "00088",
          "shortName": "голубой",
          "price": 0,
          "sortPosition": 0,
          "hexColor": "#7aa3c3"
        },
        "00428": {
          "attrValue": "00428",
          "objectId": "1b82402f630aae2a6208b8be6be637aba205f678",
          "displayName": "00428",
          "shortName": "красный",
          "price": 0,
          "sortPosition": 1,
          "hexColor": "#bd1f04"
        },
        "01700": {
          "attrValue": "01700",
          "objectId": "6bbb80a59624897fb5c1a52e74e2032191fd2aea",
          "displayName": "01700",
          "shortName": "белый",
          "price": 0,
          "sortPosition": 2,
          "hexColor": "#e5e5e5"
        },
        "07342": {
          "attrValue": "07342",
          "objectId": "172984a883b46b39f5e52dbe03748c23566301d9",
          "displayName": "07342",
          "shortName": "синий",
          "price": 0,
          "sortPosition": 3,
          "hexColor": "#6584ba"
        },
        "08313": {
          "attrValue": "08313",
          "objectId": "67a2d0e8dc727f6a0578a919a1ea302201edffa4",
          "displayName": "08313",
          "shortName": "розовый",
          "price": 0,
          "sortPosition": 4,
          "hexColor": "#e9d5d6"
        },
        "Y0274": {
          "attrValue": "Y0274",
          "objectId": "b179c6116ada94ea95a1131887f78e4c7776f508",
          "displayName": "Y0274",
          "shortName": "черный",
          "price": 0,
          "sortPosition": 5,
          "hexColor": "#2b2b2b"
        },
        "3971": {
          "attrValue": "3971",
          "objectId": "dc8367940e132bbef5b3d529a8e403c3aebd9e81",
          "displayName": "3971",
          "shortName": "салатовый",
          "price": 0,
          "sortPosition": 6,
          "hexColor": "#cee1b9"
        },
        "0634": {
          "attrValue": "0634",
          "objectId": "f2bd0e1b6956359a0a535bbd9d131647c443ab04",
          "displayName": "0634",
          "shortName": "серый",
          "price": 0,
          "sortPosition": 7,
          "hexColor": "#b2b1af"
        },
        "0417": {
          "attrValue": "0417",
          "objectId": "53f5af0f5bcf7d7ee6b1dd0711948cb70f4e920d",
          "displayName": "0417",
          "shortName": "желтый",
          "price": 0,
          "sortPosition": 8,
          "hexColor": "#ffda2a"
        },
        "0249": {
          "attrValue": "0249",
          "objectId": "17a4e960b401043a085b9c0b1491a71fde82df69",
          "displayName": "0249",
          "shortName": "бежевый",
          "price": 0,
          "sortPosition": 9,
          "hexColor": "#d9bd9e"
        },
        "0218": {
          "attrValue": "0218",
          "objectId": "0880fd7a1f1beb3bd7ed6456071699c53b19e658",
          "displayName": "0218",
          "shortName": "темно синий",
          "price": 0,
          "sortPosition": 10,
          "hexColor": "#093562"
        },
        "0179": {
          "attrValue": "0179",
          "objectId": "f0e7ecc5082f9a87fa9967ef613f9c2d866a7b1c",
          "displayName": "0179",
          "shortName": "персик",
          "price": 0,
          "sortPosition": 11,
          "hexColor": "#ecbd99"
        },
        "0044": {
          "attrValue": "0044",
          "objectId": "b2d7d45099e343b20ff88de6d8f73ccf2b6802a6",
          "displayName": "0044",
          "shortName": "коралл",
          "price": 0,
          "sortPosition": 12,
          "hexColor": "#e77d92"
        },
        "0174": {
          "attrValue": "0174",
          "objectId": "426eac44a33019273acee6831ac6dfd9536117c1",
          "displayName": "0174",
          "shortName": "шоколад",
          "price": 0,
          "sortPosition": 13,
          "hexColor": "#622b27"
        },
        "0363": {
          "attrValue": "0363",
          "objectId": "de8cbe6c5ac889eb8958d0930e3b8a16913967bc",
          "displayName": "0363",
          "shortName": "рыжий",
          "price": 0,
          "sortPosition": 14,
          "hexColor": "#da7f47"
        },
        "0375": {
          "attrValue": "0375",
          "objectId": "a19409423d9fea94ebe49ca4dc6b61842f9b8702",
          "displayName": "0375",
          "shortName": "брусника",
          "price": 0,
          "sortPosition": 15,
          "hexColor": "#cc63a2"
        },
        "0607": {
          "attrValue": "0607",
          "objectId": "dbdbbaaa76f0b29e8c168719420f4c2f6f8ea787",
          "displayName": "0607",
          "shortName": "бордо",
          "price": 0,
          "sortPosition": 16,
          "hexColor": "#892558"
        },
        "3827": {
          "attrValue": "3827",
          "objectId": "2df0317a99c83652bb170151fdc0c290ccdfaa2c",
          "displayName": "3827",
          "shortName": "сиреневый",
          "price": 0,
          "sortPosition": 17,
          "hexColor": "#c0a7e2"
        },
        "0575": {
          "attrValue": "0575",
          "objectId": "5abb7cf722695469ad3bd9f288154a84b30bd977",
          "displayName": "0575",
          "shortName": "слива",
          "price": 0,
          "sortPosition": 18,
          "hexColor": "#562e8f"
        },
        "0191": {
          "attrValue": "0191",
          "objectId": "859f74a2e5f1c1ffcc391efcb74d7802da0daf25",
          "displayName": "0191",
          "shortName": "морская волна",
          "price": 0,
          "sortPosition": 19,
          "hexColor": "#70cecf"
        },
        "0402": {
          "attrValue": "0402",
          "objectId": "481103f056eae647329f7fc558dd2815b607eaf0",
          "displayName": "0402",
          "shortName": "изумруд",
          "price": 0,
          "sortPosition": 20,
          "hexColor": "#00887c"
        },
        "3548": {
          "attrValue": "3548",
          "objectId": "0888bb222bef9c9777873808a017458207fb3fd6",
          "displayName": "3548",
          "shortName": "бирюза",
          "price": 0,
          "sortPosition": 21,
          "hexColor": "#4ca2c1"
        }
      }
    },
    "printProductNumber": {
      "attrName": "printProductNumber",
      "objectId": "90a278d256538bd917fa2df1699890d4730be84c",
      "displayName": "Вышить уникальный номер",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "false": {
          "attrValue": "false",
          "objectId": "70575abdfafd652c8de88004eeb958fc2f19d30a",
          "displayName": "Не вышивать уникальный номер",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 0
        },
        "true": {
          "attrValue": "true",
          "objectId": "80489e3462b2624ae91ed671d6e4364e154f67c1",
          "displayName": "Вышить уникальный номер",
          "shortName": "да",
          "price": 0,
          "sortPosition": 1
        }
      }
    },
    "buttonThreadDecor": {
      "attrName": "buttonThreadDecor",
      "objectId": "17b1d4e5cbc9b828d8dc04443f64d5a10d326d02",
      "displayName": "Ручная пришивка пуговиц",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "false": {
          "attrValue": "false",
          "objectId": "bf46874525725efa881a00d7b5b629c4daa8ce1e",
          "displayName": "авто",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 0
        },
        "true": {
          "attrValue": "true",
          "objectId": "8826d6212c1017cce43f72a66fbd2bddaf94b1a0",
          "displayName": "Ручная пришивка пуговиц",
          "shortName": "да",
          "price": 600,
          "sortPosition": 1
        }
      }
    },
    "collarDecor": {
      "attrName": "collarDecor",
      "objectId": "f9a05b3a852fd911ba0ba79ece3bb0521fecdd82",
      "displayName": "Ручная отделка воротника",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "false": {
          "attrValue": "false",
          "objectId": "0653e5865e44d9021f280ff970a2f7ba9a13fa6e",
          "displayName": "нет",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 0
        },
        "true": {
          "attrValue": "true",
          "objectId": "bce3d84758dacd183cb30d9aa9c3bb390ef2043e",
          "displayName": "Ручная отделка воротника",
          "shortName": "Ручная отделка воротника",
          "price": 500,
          "sortPosition": 1
        }
      }
    },
    "cuffDecor": {
      "attrName": "cuffDecor",
      "objectId": "5b83f31b9ed53c51c058663d002fe9eaf2df7b5c",
      "displayName": "Ручная отделка манжет",
      "defaultValue": "false",
      "price": 0,
      "values": {
        "false": {
          "attrValue": "false",
          "objectId": "0653e5865e44d9021f280ff970a2f7ba9a13fa6e",
          "displayName": "нет",
          "shortName": "нет",
          "price": 0,
          "sortPosition": 0
        },
        "true": {
          "attrValue": "true",
          "objectId": "bce3d84758dacd183cb30d9aa9c3bb390ef2043e",
          "displayName": "Ручная отделка манжет",
          "shortName": "Ручная отделка манжет",
          "price": 500,
          "sortPosition": 1
        }
      }
    }
  },
  "buttons": {
    "buttons": {
      "attrName": "buttons",
      "objectId": "fe6cce8ff27797a6248158369f89bc2b00000000",
      "displayName": "Пуговицы",
      "defaultValue": "SG2-1953",
      "price": "0",
      "values": {
        "10019": {
          "attrValue": 10019,
          "disabled": "false",
          "objectId": 10019,
          "displayName": 10019,
          "shortName": 10019,
          "price": 0,
          "type": "button",
          "color": 10019,
          "sortPosition": 2,
          "hexColor": "bad8e8"
        },
        "10032": {
          "attrValue": 10032,
          "disabled": "false",
          "objectId": 10032,
          "displayName": "кремовые",
          "shortName": "кремовые",
          "price": 0,
          "type": "button",
          "color": "кремовые",
          "sortPosition": 3,
          "hexColor": "e2d6bd"
        },
        "10038": {
          "attrValue": 10038,
          "disabled": "false",
          "objectId": 10038,
          "displayName": "зеленые",
          "shortName": "зеленые",
          "price": 0,
          "type": "button",
          "color": "зеленые",
          "sortPosition": 4,
          "hexColor": "72681d"
        },
        "10053": {
          "attrValue": 10053,
          "disabled": "false",
          "objectId": 10053,
          "displayName": 10053,
          "shortName": 10053,
          "price": 0,
          "type": "button",
          "color": 10053,
          "sortPosition": 5,
          "hexColor": "777a88"
        },
        "10054": {
          "attrValue": 10054,
          "disabled": "false",
          "objectId": 10054,
          "displayName": 10054,
          "shortName": 10054,
          "price": 0,
          "type": "button",
          "color": 10054,
          "sortPosition": 6,
          "hexColor": "b9b7b3"
        },
        "11018": {
          "attrValue": 11018,
          "disabled": "false",
          "objectId": 11018,
          "displayName": "перламутр стандарт",
          "shortName": "перламутр стандарт",
          "price": 800,
          "type": "button",
          "color": "перламутр стандарт",
          "sortPosition": 7,
          "hexColor": "d3e1e0"
        },
        "11050": {
          "attrValue": 11050,
          "disabled": "false",
          "objectId": 11050,
          "displayName": "перламутр скругленный",
          "shortName": "перламутр скругленный",
          "price": 800,
          "type": "button",
          "color": "перламутр скругленный",
          "sortPosition": 8,
          "hexColor": "d3e1e0"
        },
        "11060": {
          "attrValue": 11060,
          "disabled": "false",
          "objectId": 11060,
          "displayName": "перламутр мини",
          "shortName": "перламутр мини",
          "price": 800,
          "type": "button",
          "color": "перламутр мини",
          "sortPosition": 9,
          "hexColor": "d3e1e0"
        },
        "11063": {
          "attrValue": 11063,
          "disabled": "false",
          "objectId": 11063,
          "displayName": "перламутр 11063",
          "shortName": "перламутр 11063",
          "price": 800,
          "type": "button",
          "color": 11063,
          "sortPosition": 10,
          "hexColor": "e3e1d2"
        },
        "ZV0022-371": {
          "attrValue": "ZV0022-371",
          "disabled": "false",
          "objectId": "3a3bc3a19eb79d386bbcdfea575fb42d571d7122",
          "displayName": "светло-коричневый",
          "shortName": "светло-коричневый",
          "price": "0",
          "type": "button",
          "color": "светло-коричневый",
          "sortPosition": 0,
          "hexColor": "c2a970"
        },
        "A1052-350": {
          "attrValue": "A1052-350",
          "disabled": "false",
          "objectId": "A1052-350",
          "displayName": "cветло-голубые",
          "shortName": "cветло-голубые",
          "price": 0,
          "type": "button",
          "color": "cветло-голубые",
          "sortPosition": 1,
          "hexColor": "bbd8e9"
        },
        "SG2-9664": {
          "attrValue": "SG2-9664",
          "disabled": "false",
          "objectId": "ec2fe601978c8a10d48d72fba31aad2a4046ac36",
          "displayName": "бледно-сиреневый",
          "shortName": "бледно-сиреневый",
          "price": "0",
          "type": "button",
          "color": "бледно-сиреневый",
          "sortPosition": 11,
          "hexColor": "7e7692"
        },
        "SG2-3190": {
          "attrValue": "SG2-3190",
          "disabled": "false",
          "objectId": "8fc126715bf17e08ad2b0f4fe34d90e26f346bdb",
          "displayName": "сиреневый",
          "shortName": "сиреневый",
          "price": "0",
          "type": "button",
          "color": "сиреневый",
          "sortPosition": 12,
          "hexColor": "a47593",
        },
        "SG2-3789": {
          "attrValue": "SG2-3789",
          "disabled": "false",
          "objectId": "c85549e98bba03874f01c4e651c4802dad39201f",
          "displayName": "молочный",
          "shortName": "молочный",
          "price": "0",
          "type": "button",
          "color": "молочный",
          "sortPosition": 13,
          "hexColor": "f5eddf"
        },
        "SG2-2827": {
          "attrValue": "SG2-2827",
          "disabled": "false",
          "objectId": "5467a26c999f6b18738dbd9db94defa3ba4e0957",
          "displayName": "светло-коричневый",
          "shortName": "светло-коричневый",
          "price": "0",
          "type": "button",
          "color": "светло-коричневый",
          "sortPosition": 14,
          "hexColor": "b78c55"
        },
        "SG2-1992": {
          "attrValue": "SG2-1992",
          "disabled": "false",
          "objectId": "05c0adc34aef014dc99ccc39f73791ae15b24022",
          "displayName": "голубой",
          "shortName": "голубой",
          "price": "0",
          "type": "button",
          "color": "голубой",
          "sortPosition": 15,
          "hexColor": "7095b6"
        },
        "SG2-1452": {
          "attrValue": "SG2-1452",
          "disabled": "false",
          "objectId": "e20bfc0d9300fb29799abad4d40f32513c0c055a",
          "displayName": "розовый",
          "shortName": "розовый",
          "price": "0",
          "type": "button",
          "color": "розовый",
          "sortPosition": 16,
          "hexColor": "ce869b"
        },
        "SG2-0512": {
          "attrValue": "SG2-0512",
          "disabled": "false",
          "objectId": "06944d7922d0563d653ee8c4f9468b154569fe84",
          "displayName": "сливовый",
          "shortName": "сливовый",
          "price": "0",
          "type": "button",
          "color": "сливовый",
          "sortPosition": 17,
          "hexColor": "1b1321"
        },
        "SG2-0406": {
          "attrValue": "SG2-0406",
          "disabled": "false",
          "objectId": "39ae4e38d837eeec623e1f96c9071cc89dabdb93",
          "displayName": "шоколад",
          "shortName": "шоколад",
          "price": "0",
          "type": "button",
          "color": "шоколад",
          "sortPosition": 18,
          "hexColor": "2b1710"
        },
        "SG2-0050": {
          "attrValue": "SG2-0050",
          "disabled": "false",
          "objectId": "1e9dfc653f590d9146547f0351d546058c9ab92b",
          "displayName": "кремовый",
          "shortName": "кремовый",
          "price": "0",
          "type": "button",
          "color": "кремовый",
          "sortPosition": 19,
          "hexColor": "bcb4a5"
        },
        "SG2-0038": {
          "attrValue": "SG2-0038",
          "disabled": "false",
          "objectId": "62461a7b1b3f3d5b8147397fa77a40012c5911f6",
          "displayName": "серый",
          "shortName": "серый",
          "price": "0",
          "type": "button",
          "color": "серый",
          "sortPosition": 20,
          "hexColor": "d2ced1"
        },
        "SG2-1953": {
          "attrValue": "SG2-1953",
          "disabled": "false",
          "objectId": "1b48701bfe65d654cb093cb9756e5eb2c63972a7",
          "displayName": "белый",
          "shortName": "белый",
          "price": "0",
          "type": "button",
          "color": "белый",
          "sortPosition": 21,
          "hexColor": "e1dfd9"
        },
        "SG2-1130": {
          "attrValue": "SG2-1130",
          "disabled": "false",
          "objectId": "6ae6ab69b2e80f889d6926b7b714022a69ed1091",
          "displayName": "красный",
          "shortName": "красный",
          "price": "0",
          "type": "button",
          "color": "красный",
          "sortPosition": 22,
          "hexColor": "8f0f21"
        },
        "SG2-0000": {
          "attrValue": "SG2-0000",
          "disabled": "false",
          "objectId": "3ee64281e689c35ec9407ee26e26aa7792586806",
          "displayName": "черный",
          "shortName": "черный",
          "price": "0",
          "type": "button",
          "color": "черный",
          "sortPosition": 23,
          "hexColor": "141414"
        },
        "TL0008-C891": {
          "attrValue": "TL0008-C891",
          "disabled": "false",
          "objectId": "413c0480a24f2012081b086949cab19113404b75",
          "displayName": "персиковый",
          "shortName": "персиковый",
          "price": "0",
          "type": "button",
          "color": "персиковый",
          "sortPosition": 24,
          "hexColor": "ce9142"
        },
        "1-5": {
          "attrValue": "1-5",
          "disabled": "false",
          "objectId": "4b2b2c70f09466e90fb2a7498dfda2906c0eb33f",
          "displayName": "Перламутровые пуговицы",
          "shortName": "натуральный перламутр",
          "price": 800,
          "type": "button",
          "color": "натуральный перламутр",
          "sortPosition": 25,
          "hexColor": "d1dfd8"
        },
        "1-4": {
          "attrValue": "1-4",
          "disabled": "false",
          "objectId": "ae8b49d52cb19472419014eb4c3d9c33a9b6a8b3",
          "displayName": "натуральный перламутр крем-брюле",
          "shortName": "перламутр крем-брюле",
          "price": 800,
          "type": "button",
          "color": "перламутр крем-брюле",
          "sortPosition": 26,
          "hexColor": "e0d3c2"
        },
        "1-3": {
          "attrValue": "1-3",
          "disabled": "false",
          "objectId": "c7438d8370257d8996b5cf960e379f3c59ac0dc3",
          "displayName": "натуральный перламутр корица",
          "shortName": "перламутр корица",
          "price": 800,
          "type": "button",
          "color": "перламутр корица",
          "sortPosition": 27,
          "hexColor": "a79492"
        },
        "1-2": {
          "attrValue": "1-2",
          "disabled": "false",
          "objectId": "432b1b41445c5389ddb3f87886937dab8fa74cef",
          "displayName": "натуральный перламутр ваниль",
          "shortName": "перламутр ваниль",
          "price": 800,
          "type": "button",
          "color": "перламутр ваниль",
          "sortPosition": 28,
          "hexColor": "e8e0d0"
        },
        "1-1": {
          "attrValue": "1-1",
          "disabled": "false",
          "objectId": "858a069c207075a5bf804011b34a6f7fa3bc8223",
          "displayName": "натуральный перламутр муссон",
          "shortName": "перламутр муссон",
          "price": 800,
          "type": "button",
          "color": "перламутр муссон",
          "sortPosition": 29,
          "hexColor": "5c636e"
        },
        "4-5": {
          "attrValue": "4-5",
          "disabled": "false",
          "objectId": "413c0480a24f44081b086949cab19113404b44",
          "displayName": "перламутр трио",
          "shortName": "перламутр трио",
          "price": 800,
          "type": "button",
          "color": "перламутр трио",
          "sortPosition": 30,
          "hexColor": "d7d5d0"
        },
        "perl-525": {
          "attrValue": "perl-525",
          "disabled": "false",
          "objectId": "f2c78945444dd2eeaeab3b16e9bd1a58a6baa3da",
          "displayName": "Перламутровые пуговицы",
          "shortName": "натуральный перламутр",
          "price": 800,
          "type": "button",
          "color": "натуральный перламутр",
          "sortPosition": 31,
          "hexColor": "d7d5d0"
        },
        "b_1807-09": {
          "attrValue": "b_1807-09",
          "disabled": "false",
          "objectId": "5fc576600fa94c726d768838d36b4b8bffef2b01",
          "displayName": "Кнопки 1807-09",
          "shortName": "Кнопки 1807-09",
          "price": 100,
          "type": "snap",
          "color": "",
          "sortPosition": 32,
          "hexColor": ""
        },
        "b_1827-10": {
          "attrValue": "b_1827-10",
          "disabled": "false",
          "objectId": "84e5c672552c9450a2e70f99e12eb5bdff313f28",
          "displayName": "Кнопки 1827-10",
          "shortName": "Кнопки 1827-10",
          "price": 100,
          "type": "snap",
          "color": "",
          "sortPosition": 33,
          "hexColor": ""
        },
        "b_1880-11": {
          "attrValue": "b_1880-11",
          "disabled": "false",
          "objectId": "2e83f5a05b12882cb59366cc8a344e396395aed1",
          "displayName": "Кнопки 1880-11",
          "shortName": "Кнопки 1880-11",
          "price": 100,
          "type": "snap",
          "color": "",
          "sortPosition": 34,
          "hexColor": ""
        },
        "SG2-0711": {
          "attrValue": "SG2-0711",
          "disabled": "false",
          "objectId": "e539342d49084747f848cbc55b58dc53aa7a2e0b",
          "displayName": "синий",
          "shortName": "синий",
          "price": 0,
          "type": "button",
          "color": "синий",
          "sortPosition": 35,
          "hexColor": "385482"
        },
        "P1932-912": {
          "attrValue": "P1932-912",
          "disabled": "false",
          "objectId": "e2b0b5bf15513262860587e5b13de132ed9a0adb",
          "displayName": "фуксия",
          "shortName": "фуксия",
          "price": 0,
          "type": "button",
          "color": "фуксия",
          "sortPosition": 36,
          "hexColor": "a81e92"
        },
        "P1932-910": {
          "attrValue": "P1932-910",
          "disabled": "false",
          "objectId": "b522547a02ed22006dc4b7b40e2f6ad21ff303b3",
          "displayName": "гранатовый",
          "shortName": "гранатовый",
          "price": 0,
          "type": "button",
          "color": "гранатовый",
          "sortPosition": 37,
          "hexColor": "851d36"
        },
        "P1932-763": {
          "attrValue": "P1932-763",
          "disabled": "false",
          "objectId": "3b3106c35e8f75ee102790758837f20659fd4a8f",
          "displayName": "бирюза",
          "shortName": "бирюза",
          "price": 0,
          "type": "button",
          "color": "бирюза",
          "sortPosition": 38,
          "hexColor": "48948c",
        },
        "P1932-4248": {
          "attrValue": "P1932-4248",
          "disabled": "false",
          "objectId": "0bdc8cfc1b5f28d6a04671fa2f7bcf2a8ca03068",
          "displayName": "карминовый",
          "shortName": "карминовый",
          "price": 0,
          "type": "button",
          "color": "карминовый",
          "sortPosition": 40,
          "hexColor": "921961"
        },
        "P1932-392": {
          "attrValue": "P1932-392",
          "disabled": "false",
          "objectId": "df4cb6dd09d7c1bf96d95b655cfbec2f70279d95",
          "displayName": "фиолетовый",
          "shortName": "фиолетовый",
          "price": 0,
          "type": "button",
          "color": "фиолетовый",
          "sortPosition": 41,
          "hexColor": "564da2"
        },
        "P1932-1328": {
          "attrValue": "P1932-1328",
          "disabled": "false",
          "objectId": "9a3d5e61bfedd2ea10c8dabd028d480ad1b36fdb",
          "displayName": "светло-синий",
          "shortName": "светло-синий",
          "price": 0,
          "type": "button",
          "color": "светло-синий",
          "sortPosition": 42,
          "hexColor": "274aaa"
        },
        "P1932-1064": {
          "attrValue": "P1932-1064",
          "disabled": "false",
          "objectId": "769cf5480e6def9f7952eaef79c06776c11dc220",
          "displayName": "нежно-сиреневый",
          "shortName": "нежно-сиреневый",
          "price": 0,
          "type": "button",
          "color": "нежно-сиреневый",
          "sortPosition": 43,
          "hexColor": "9b90c5"
        },
        "b_1831-10": {
          "attrValue": "b_1831-10",
          "disabled": "false",
          "objectId": "58f8df3ea7ee23084706c0a3f3b3c725f911aaf8",
          "displayName": "b_1831-10",
          "shortName": "Кнопки 1831-10",
          "price": 100,
          "type": "snap",
          "color": "",
          "sortPosition": 44,
          "hexColor": ""
        },
        "ZV0022-001": {
          "attrValue": "ZV0022-001",
          "disabled": "false",
          "objectId": "d5fcfed890bfdfed3411514afbf81523707eeae2",
          "displayName": "ZV0022-001",
          "shortName": "ZV0022-001",
          "price": 0,
          "type": "button",
          "color": "ZV0022-001",
          "sortPosition": 45,
          "hexColor": "c7c9cc"
        },
        "RT0075-A066": {
          "attrValue": "RT0075-A066",
          "disabled": "false",
          "objectId": "87645de98ffa7eda7330ce70ab50995a24f4cdfe",
          "displayName": "бежевый",
          "shortName": "бежевый",
          "price": 0,
          "type": "button",
          "color": "бежевый",
          "sortPosition": 46,
          "hexColor": "bda35f"
        },
        "RT0075-A013": {
          "attrValue": "RT0075-A013",
          "disabled": "false",
          "objectId": "b5c171a6fd840683f1e6568f6ba5a79e53fc1efe",
          "displayName": "RT0075-A013",
          "shortName": "RT0075-A013",
          "price": 0,
          "type": "button",
          "color": "RT0075-A013",
          "sortPosition": 47,
          "hexColor": "a37352",
        },
        "RT0075-A124": {
          "attrValue": "RT0075-A124",
          "disabled": "false",
          "objectId": "ce3b65400ada9098eeccfbe6a10d39ab89d3d7e6",
          "displayName": "RT0075-A124",
          "shortName": "RT0075-A124",
          "price": 0,
          "type": "button",
          "color": "RT0075-A124",
          "sortPosition": 48,
          "hexColor": "7c93b0"
        },
        "RT0075-A021": {
          "attrValue": "RT0075-A021",
          "disabled": "false",
          "objectId": "d0bafac0d2ee305fecf9addc54bc344902b94edc",
          "displayName": "RT0075-A021",
          "shortName": "RT0075-A021",
          "price": 0,
          "type": "button",
          "color": "RT0075-A021",
          "sortPosition": 49,
          "hexColor": "7fbbe6"
        },
        "TL0008-C154": {
          "attrValue": "TL0008-C154",
          "disabled": "false",
          "objectId": "e1d46a91d54a5e31bfe137e426cf99de356c8347",
          "displayName": "TL0008-C154",
          "shortName": "TL0008-C154",
          "price": 0,
          "type": "button",
          "color": "TL0008-C154",
          "sortPosition": 50,
          "hexColor": "7c775b"
        },
        "TL0008-C055": {
          "attrValue": "TL0008-C055",
          "disabled": "false",
          "objectId": "3e3420892798066ccc0fea50e603e63522b8cb27",
          "displayName": "молоко",
          "shortName": "молоко",
          "price": 0,
          "type": "button",
          "color": "молоко",
          "sortPosition": 51,
          "hexColor": "d1c484"
        },
        "TL0008-C288": {
          "attrValue": "TL0008-C288",
          "disabled": "false",
          "objectId": "47bc1ffa2ea32c49e4e33007559252118775d165",
          "displayName": "TL0008-C288",
          "shortName": "TL0008-C288",
          "price": 0,
          "type": "button",
          "color": "TL0008-C288",
          "sortPosition": 52,
          "hexColor": "881f43"
        },
        "P1932-3784": {
          "attrValue": "P1932-3784",
          "disabled": "false",
          "objectId": "1e27c3f92535e1d9f417912a42e66e6673532400",
          "displayName": "лазурь",
          "shortName": "лазурь",
          "price": 0,
          "type": "button",
          "color": "лазурь",
          "sortPosition": 53,
          "hexColor": "aacfe8"
        },
        "A7455-965": {
          "attrValue": "A7455-965",
          "disabled": "false",
          "objectId": "3fa426490696e5f0b01e06645e2f7bce831ff773",
          "displayName": "темно-голубой",
          "shortName": "темно-голубой",
          "price": 0,
          "type": "button",
          "color": "темно-голубой",
          "sortPosition": 54,
          "hexColor": "7f93c3"
        },
        "A7455-866": {
          "attrValue": "A7455-866",
          "disabled": "false",
          "objectId": "2c536db0a18121242c925cd95682085fa3b75121",
          "displayName": "пурпурный",
          "shortName": "пурпурный",
          "price": 0,
          "type": "button",
          "color": "пурпурный",
          "sortPosition": 55,
          "hexColor": "8567ae"
        },
        "A7455-black": {
          "attrValue": "A7455-black",
          "disabled": "false",
          "objectId": "576918d7f0646cc2d0f0f1aca3b7fc631e18e8f9",
          "displayName": "смоляной",
          "shortName": "смоляной",
          "price": 0,
          "type": "button",
          "color": "смоляной",
          "sortPosition": 56,
          "hexColor": "25262d"
        },
        "A7455-862": {
          "attrValue": "A7455-862",
          "disabled": "false",
          "objectId": "8dd164731a08fb08e9fd7fcf21bfe95ddbe0a3db",
          "displayName": "фиалковый",
          "shortName": "фиалковый",
          "price": 0,
          "type": "button",
          "color": "фиалковый",
          "sortPosition": 57,
          "hexColor": "ab96d1"
        },
        "A7455-571": {
          "attrValue": "A7455-571",
          "disabled": "false",
          "objectId": "b15490a410a7a9f003645dfcd61eb11b285c1612",
          "displayName": "беж",
          "shortName": "беж",
          "price": 0,
          "type": "button",
          "color": "беж",
          "sortPosition": 58,
          "hexColor": "efefec"
        },
        "A7455-039": {
          "attrValue": "A7455-039",
          "disabled": "false",
          "objectId": "34ac7308be1b35777bfef1c8d72ca229b0646175",
          "displayName": "сапфир",
          "shortName": "сапфир",
          "price": 0,
          "type": "button",
          "color": "сапфир",
          "sortPosition": 59,
          "hexColor": "2d3272"
        },
        "A7455-361": {
          "attrValue": "A7455-361",
          "disabled": "false",
          "objectId": "6f6a5069c10a40319f85a84c4f697a4ffadbc4b4",
          "displayName": "циркон",
          "shortName": "циркон",
          "price": 0,
          "type": "button",
          "color": "циркон",
          "sortPosition": 60,
          "hexColor": "d8dfe6"
        },
        "A7455-347": {
          "attrValue": "A7455-347",
          "disabled": "false",
          "objectId": "931ce07eaf1c6787f8a9f2ef425cc8767debbe02",
          "displayName": "светло-серый",
          "shortName": "светло-серый",
          "price": 0,
          "type": "button",
          "color": "светло-серый",
          "sortPosition": 61,
          "hexColor": "d8dfe6",
        },
        "A7455-230": {
          "attrValue": "A7455-230",
          "disabled": "false",
          "objectId": "4abc36803cfc32d053e65b20bd35b0fc136e29ad",
          "displayName": "баклажан",
          "shortName": "баклажан",
          "price": 0,
          "type": "button",
          "color": "баклажан",
          "sortPosition": 62,
          "hexColor": "692862"
        },
        "A7455-028": {
          "attrValue": "A7455-028",
          "disabled": "false",
          "objectId": "17d1ee0d285fb539a87058666489b4e4812abc4e",
          "displayName": "бирюзовый",
          "shortName": "бирюзовый",
          "price": 0,
          "type": "button",
          "color": "бирюзовый",
          "sortPosition": 63,
          "hexColor": "00c9e1",
        },
        "A7455-051": {
          "attrValue": "A7455-051",
          "disabled": "false",
          "objectId": "A7455-051",
          "displayName": "темно-голубой",
          "shortName": "темно-голубой",
          "price": 0,
          "type": "button",
          "color": "темно-голубой",
          "sortPosition": 64,
          "hexColor": "9bb4d9"
        },
        "A7455-350": {
          "attrValue": "A7455-350",
          "disabled": "false",
          "objectId": "A7455-350",
          "displayName": "небесный",
          "shortName": "небесный",
          "price": 0,
          "type": "button",
          "color": "небесный",
          "sortPosition": 65,
          "hexColor": "9fc3dd"
        },
        "A7455-000": {
          "attrValue": "A7455-000",
          "disabled": "false",
          "objectId": "A7455-000",
          "displayName": "сливочный",
          "shortName": "сливочный",
          "price": 0,
          "type": "button",
          "color": "сливочный",
          "sortPosition": 66,
          "hexColor": "dbe1e5",
        },
        "A7455-558": {
          "attrValue": "A7455-558",
          "disabled": "false",
          "objectId": "A7455-558",
          "displayName": "синий",
          "shortName": "синий",
          "price": 0,
          "type": "button",
          "color": "синий",
          "sortPosition": 67,
          "hexColor": "486697"
        },
        "A7455-302": {
          "attrValue": "A7455-302",
          "disabled": "false",
          "objectId": "A7455-302",
          "displayName": "светло-синий",
          "shortName": "светло-синий",
          "price": 0,
          "type": "button",
          "color": "светло-синий",
          "sortPosition": 68,
          "hexColor": "748fcb"
        },
        "A7455-068": {
          "attrValue": "A7455-068",
          "disabled": "false",
          "objectId": "A7455-068",
          "displayName": "розовый",
          "shortName": "розовый",
          "price": 0,
          "type": "button",
          "color": "розовый",
          "sortPosition": 69,
          "hexColor": "748fcb"
        },
        "Rus-flag": {
          "attrValue": "Rus-flag",
          "disabled": "false",
          "objectId": "Rus-flag",
          "displayName": "флаг РФ",
          "shortName": "флаг РФ",
          "price": 600,
          "type": "button",
          "color": "флаг РФ",
          "sortPosition": 70,
          "hexColor": ''
        }
      }
    }
  },
  "fabrics": {
    "fabric": {
      "attrName": "fabric",
      "objectId": "b2931d7594c30ff6a68ac89a4c7a42cc00000000",
      "displayName": "Ткань",
      "defaultValue": "bodyShirt_garut-light-blue1998x1980-new",
      "price": 0,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet"
        ]
      }
    },
    "collarFabric": {
      "attrName": "collarFabric",
      "objectId": "ca2560d431620405a2df247a880b3eb7dbf0af4b",
      "displayName": "Ткань воротника",
      "defaultValue": "big_lambert",
      "price": 150,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    },
    "collarStandFabric": {
      "attrName": "collarStandFabric",
      "objectId": "70a439cc6a5e16664eccaa9d80641dbd0e1a9e02",
      "displayName": "Ткань стойки ворота",
      "defaultValue": "lambert_brown",
      "price": 100,
      "values": {
        "fabric": [],
        "fabricSet": [
          "ContrastFabricSet",
          "GenericFabricSet"
        ]
      }
    },
    "collarStandFrontFabric": {
      "attrName": "collarStandFrontFabric",
      "objectId": "70a639cc6a5e16564eccaa9d80641dbd0e1a9e02",
      "displayName": "Ткань внешней стойки ворота",
      "defaultValue": "lambert_brown",
      "price": 100,
      "values": {
        "fabric": [],
        "fabricSet": [
          "ContrastFabricSet",
          "GenericFabricSet"
        ]
      }
    },
    "sleeveFabric": {
      "attrName": "sleeveFabric",
      "objectId": "70a539cc6a5e16664eccaa9d80641dbd0e1a9e02",
      "displayName": "Ткань рукава",
      "defaultValue": "lambert_brown",
      "price": 100,
      "values": {
        "fabric": [],
        "fabricSet": [
          "ContrastFabricSet",
          "GenericFabricSet"
        ]
      }
    },
    "contrastFabric": {
      "attrName": "contrastFabric",
      "objectId": "78811370e70ef3513e839fe0b308678c00000000",
      "displayName": "Контрастная ткань стойки и подманжеты",
      "defaultValue": "lambert_brown",
      "price": 200,
      "values": {
        "fabric": [
          "5580-100"
        ],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    },
    "cuffFabric": {
      "attrName": "cuffFabric",
      "objectId": "dc6fd8e291062164cda123672c5ec5682c8cd72c",
      "displayName": "Ткань манжет",
      "defaultValue": "lambert_brown",
      "price": 150,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    },
    "cuffTurnFabric": {
      "attrName": "cuffTurnFabric",
      "objectId": "659aa19bd69cf0d624f37b048902c10a432c6709",
      "displayName": "Ткань нижней манжеты",
      "defaultValue": "lambert_brown",
      "price": 150,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    },
    "fasteningFabric": {
      "attrName": "fasteningFabric",
      "objectId": "88aa3ec43ad47b0465c6a4f94fc3cfea3607dfed",
      "displayName": "Ткань застежки",
      "defaultValue": "lambert_brown",
      "price": 0,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    },
    "fasteningThreadsFabric": {
      "attrName": "fasteningThreadsFabric",
      "objectId": "3f9f01d3332a9a5caa8b23b492a24ae24b996485",
      "displayName": "Ткань на петельной планке",
      "defaultValue": "lambert_brown",
      "price": 200,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    },
    "fasteningButtonsFabric": {
      "attrName": "fasteningButtonsFabric",
      "objectId": "d01bc09f609ea2352920e4c443a06c765cffeaa7",
      "displayName": "Ткань на пуговичной планке",
      "defaultValue": "lambert_brown",
      "price": 200,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    },
    "doubleCollarContrastFabric": {
      "attrName": "doubleCollarContrastFabric",
      "objectId": "110168ae89cd997799871f6f5c14b408e427a8f7",
      "displayName": "Ткань второго отлета или канта ворота",
      "defaultValue": "lambert_brown",
      "price": 0,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    },
    "threebleCollarContrastFabric": {
      "attrName": "threebleCollarContrastFabric",
      "objectId": "766208e38a6d8c2ed195d5f4933f6d7944323fe9",
      "displayName": "Ткань третьего отлета ворота",
      "defaultValue": "lambert_brown",
      "price": 0,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    },
    "pocketsFabric": {
      "attrName": "pocketsFabric",
      "objectId": "908bd8598f472312dd6041e6bb9218cc1872617f",
      "displayName": "Ткань карманов",
      "defaultValue": "lambert_brown",
      "price": 100,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    },
    "epaulettesFabric": {
      "attrName": "epaulettesFabric",
      "objectId": "c0d6ff493f54b004207a2adfa1774d8edbc8a71b",
      "displayName": "Ткань эполет",
      "defaultValue": "lambert_brown",
      "price": 100,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    },
    "patchFabric": {
      "attrName": "patchFabric",
      "objectId": "62c7e9235205471b525ef8acacc4ae445b21cffa",
      "displayName": "Ткань заплаток",
      "defaultValue": "lambert_brown",
      "price": 100,
      "values": {
        "fabric": [],
        "fabricSet": [
          "GenericFabricSet",
          "ContrastFabricSet"
        ]
      }
    }
  },
  "sizes": {
    "height": {
      "attrName": "height",
      "disabled": "false",
      "objectId": "",
      "displayName": "Рост"
    },
    "stdSize": {
      "attrName": "stdSize",
      "disabled": "false",
      "objectId": "",
      "displayName": "Размер ворота"
    },
    "neckAround": {
      "attrName": "neckAround",
      "disabled": "false",
      "objectId": "",
      "displayName": "Обхват шеи"
    },
    "chestAround": {
      "attrName": "chestAround",
      "disabled": "false",
      "objectId": "",
      "displayName": "Обхват груди"
    },
    "waistAround": {
      "attrName": "waistAround",
      "disabled": "false",
      "objectId": "",
      "displayName": "Обхват талии"
    },
    "seatAround": {
      "attrName": "seatAround",
      "disabled": "false",
      "objectId": "",
      "displayName": "Обхват бедер"
    },
    "bicepsAround": {
      "attrName": "bicepsAround",
      "disabled": "false",
      "objectId": "",
      "displayName": "Обхват бицепса"
    },
    "wristAround": {
      "attrName": "wristAround",
      "disabled": "false",
      "objectId": "",
      "displayName": "Обхват запястья"
    },
    "lengthToShoulder": {
      "attrName": "lengthToShoulder",
      "disabled": "true",
      "objectId": "",
      "displayName": "Длина плечевого ската"
    },
    "sleeveLength": {
      "attrName": "sleeveLength",
      "disabled": "false",
      "objectId": "",
      "displayName": "Длина длинного рукава"
    },
    "shortSleeveLength": {
      "attrName": "shortSleeveLength",
      "disabled": "false",
      "objectId": "",
      "displayName": "Длина короткого рукава"
    },
    "waistLengthFront": {
      "attrName": "waistLengthFront",
      "disabled": "true",
      "objectId": "",
      "displayName": "Высота от талии спереди"
    },
    "shoulderHeightFront": {
      "attrName": "shoulderHeightFront",
      "disabled": "true",
      "objectId": "",
      "displayName": "Высота плеча косая спереди"
    },
    "waistLengthBack": {
      "attrName": "waistLengthBack",
      "disabled": "true",
      "objectId": "",
      "displayName": "Длина спины до талии"
    },
    "shoulderHeightBack": {
      "attrName": "shoulderHeightBack",
      "disabled": "true",
      "objectId": "",
      "displayName": "Высота плеча косая сзади"
    },
    "chestWidth": {
      "attrName": "chestWidth",
      "disabled": "true",
      "objectId": "",
      "displayName": "Ширина груди"
    },
    "backWidth": {
      "attrName": "backWidth",
      "disabled": "true",
      "objectId": "",
      "displayName": "Ширина спины"
    },
    "shirtLength": {
      "attrName": "shirtLength",
      "disabled": "false",
      "objectId": "",
      "displayName": "Длина рубашки"
    }
  }
}
